
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class JoeyLoading extends Vue {}
